<template lang="pug">
  v-app.loans(id="app")
    v-content
      header
        v-layout(wrap align-center row fill-height primary)
          v-flex.hidden-md-and-up(xs2 sm1 v-if="$route.path !== '/prestamos/registro-exitoso'")
            img.mt-2(src="@/assets/icons/arrow-back.svg" srcset="@/assets/icons/back.svg" alt="Regresar" @click="backPage"  style="cursor: pointer")
          v-flex(xs8 sm6 @click="$router.push( '/inicio' )" v-if="$route.path !== '/prestamos/registro-exitoso'")
            h1.white--text.omnesMedium Préstamos
          v-flex(xs10 sm6 @click="$router.push( '/inicio' )" v-else)
            h1.white--text.omnesMedium.text-xs-center.text-sm-left Préstamos
          v-flex.container--logout.text-sm-right.text-xs-center.hidden-md-and-up(xs2 sm5 v-if="$route.path !== '/prestamos/registro-exitoso'")
            img.call(src="@/assets/loans/telefono.svg" srcset="@/assets/loans/telefono.svg" alt="Llamar algún contacto" @click="showContact = !showContact"  style="cursor: pointer")
          v-flex.container--logout.text-sm-right(sm5 md6 :class="[$route.path === '/prestamos/registro-exitoso' ? 'lg6' : '']")
            v-btn.hidden-xs-only.mx-0(outline color="white")
              a.logout.omnesRegular.white--text(href="#" v-on:click="logout($event)") Cerrar sesión
      v-layout.main(wrap justify-center)
        v-flex.hidden-sm-and-down.volver(v-if="$route.path !== '/prestamos/registro-exitoso'")
          img.mt-2(src="@/assets/loans/regresar_gris.svg"  alt="Regresar" @click="backPage")
        router-view
        transition(name="slide-fade")
          div.white-transparent(:class="[showContact ? 'bg-white' : '']" v-if="showContact")
            div
            v-content
              v-layout.mt-5(row wrap align-center)
                v-flex.text-xs-right.border_text(offset-xs5 xs4)
                  div
                    a(target="_blank" :href="links.WhatsApp" style="cursor: pointer;text-decoration: none;")
                      h3 Contáctanos
                v-flex.text-xs-left(xs3)
                  a(target="_blank" :href="links.WhatsApp" )
                    img.call(src="@/assets/new-home/icon-chat.svg" srcset="@/assets/new-home/icon-chat.svg" alt="Chat web" @click="showContact = !showContact"  style="cursor: pointer")
              //- v-layout.mt-4(row wrap align-center)
                //- a(target="_blank" :href="`https://api.whatsapp.com/send?phone=51955539688&text=Hola`" )
                v-flex.text-xs-right.border_text(offset-xs5 xs4)
                  div
                      h3 Escríbenos
                v-flex.text-xs-left(xs3)
                  //- a(target="_blank" :href="`https://web.whatsapp.com/send?text=${textoComparte} ${urlShared}${utmwhatsapp}`" )
                  a(target="_blank" :href="`https://api.whatsapp.com/send?phone=51933559693&text=Hola`" )
                    img.call(src="@/assets/loans/telefono.svg" srcset="@/assets/loans/whatsapp.svg" alt="Llamar algún contacto" @click="showContact = !showContact"  style="cursor: pointer")
        div#contact_call.hidden-sm-and-down(v-if="!$route.path.includes('prepago') && !$route.path.includes('proceso-prestamo')")
          v-content
            v-layout.mt-5(row wrap align-end)
              v-flex.text-xs-right.border_text.pr-2(xs9)
                a(target="_blank" :href="links.WhatsApp" style="cursor: pointer;text-decoration: none;")
                  h3 Contáctanos
              v-flex.text-xs-left(xs3 style="height: 2.9rem;")
                a(target="_blank" :href="links.WhatsApp" )
                  img.call(src="@/assets/new-home/icon-chat.svg" srcset="@/assets/new-home/icon-chat.svg" alt="Chat web" @click="showContact = !showContact"  style="cursor: pointer")
            //- v-layout.mt-4(row wrap align-end)
              v-flex.text-xs-right.border_text.pr-2(xs9)
                //- a(target="_blank" :href="`https://api.whatsapp.com/send?phone=51955539688&text=Hola`" )
                p Escríbenos
                a(target="_blank" :href="`https://api.whatsapp.com/send?phone=51933559693&text=Hola`" style="cursor: pointer;text-decoration: none;")
                  div
                    h4 933559693
              v-flex.text-xs-left(xs3 style="height: 2.9rem;")
                //- a(target="_blank" :href="`https://web.whatsapp.com/send?text=${textoComparte} ${urlShared}${utmwhatsapp}`" )
                a(target="_blank" :href="`https://api.whatsapp.com/send?phone=51933559693&text=Hola`" )
                  img.call(src="@/assets/loans/telefono.svg" srcset="@/assets/loans/whatsapp.svg" alt="Llamar algún contacto" @click="showContact = !showContact"  style="cursor: pointer")
        //- LOADER PROCESS
        v-dialog(v-model="loader" persistent width="300")
          v-card(color="primary" dark="")
            v-card-text
              | {{ message }}
              v-progress-linear.mb-0(indeterminate="" color="white")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Links from '../interfaces/links'

export default {
  data () {
    return {
      links: Links,
      message: '',
      loader: false,
      showContact: false
    }
  },
  methods: {
    ...mapActions('user', ['setEstadoPrestamo']),
    backPage () {
      let self = this
      if (this.$route.path === '/prestamos/paso/cotizar') {
        if (this.$store.state.loans.onboarding === 1) {
          this.message = 'Regresando al Menú Principal...'
          this.loader = true
          if (this.userInfo != null) {
            this.setEstadoPrestamo({ codigoUsuario: self.userInfo.codigoUsuario, flag: false })
              .then(res => {
                this.loader = false
                this.$router.push('/inicio')
              })
          } else {
            this.loader = false
            this.$router.push('/inicio')
          }
          this.$gtm.trackEvent({
          "event":"select_button",
          "Nombre Sección":"Zona Segura",
          "TipoElemento":"Botón",
          "TipoAccion":"Préstamo - paso 1 - volver",
          "CTA":"Volver paso1 a home"
      })

        } else if (this.$store.state.loans.onboarding >= 2) {
          const currentStep = this.$store.state.loans.onboarding
          const prevStep = currentStep - 1
          self.$root.$emit('nextStep', { step: prevStep, possibility: self.$store.state.loans.possibility })
          this.$gtm.trackEvent({
            event: 'select_button',
            'Nombre Sección': 'Zona Segura',
            TipoElemento: 'Botón',
            TipoAccion: `Préstamo - paso ${currentStep} - volver`,
            CTA: `Volver paso${currentStep} a paso${prevStep}`
          })
        }
      } else if (this.$route.path === '/prestamos/operaciones') {
        this.$gtm.trackEvent({
          "event":"select_button",
          "Nombre Sección":"Zona Segura",
          "TipoElemento":"Botón",
          "TipoAccion":"Préstamo operaciones - volver",
          "CTA":"Volver"
        })
        this.$router.back()
      } else {
        this.$router.back()
      }
    },
    logout (evt) {
      evt.preventDefault()
      this.message = 'Cerrando Sesión...'
      sessionStorage.removeItem('infoPoliza')
      this.loader = true
      this.$root.$emit('leavingPage', {})
      this.setEstadoPrestamo({ codigoUsuario: this.userInfo.codigoUsuario, flag: false })
        .then(res => {
          this.loader = false
          this.$root.$emit('clearAllIntervals', {})
          if (localStorage.removeItem('jwt') !== null) {
            this.$store.state.user.haveLoanRequested = null
            this.$store.state.user.session = null
            this.$store.state.user.jwt = null
            this.$store.state.user.coUs = null
            this.$store.state.user.info = null
            this.$store.state.user.user = null
            this.$store.state.user.polizas = null
            this.$store.state.user.historyPayments = null
            this.$store.state.user.exp = null
            this.$store.state.user.names = null
            localStorage.removeItem('products')
            this.$router.push('/')
          }
        })
    }
  },
  computed: {
    ...mapGetters('user', ['userInfo'])
  },
  mounted () {
    this.$amplitude.getInstance().identify(new this.$amplitude.Identify())
    
    // Registra evento GTM cuando se carga la página de operaciones
    if (this.$route.path === '/prestamos/operaciones') {
      this.$gtm.trackEvent({
        event: 'content-view',
        'content-name': '/zona-segura/prestamos/operaciones',
        'content-view-name': 'Préstamo operaciones'
      })
    }
  }
}
</script>

<style>
.slide-fade-enter-active {
  transition: all .2s ease;
}
.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(21px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/layouts/LayoutLoans.vue